import {useDispatch, useSelector} from "react-redux";
import {useMemo} from "react";
import ServerData from "../../../common/serverData";
import {constants} from "../../../common/constants/constants";
import {clearToken} from "../store/slice";

/**
 * @param {boolean} useAccessToken
 * @return {ServerData | null}
 * */
export function useTenantApiClient(useAccessToken = true) {
    // NOTE: in case we are using this hook in Index, tenantProfile may be undefined until rehydrated
    const accessToken = useSelector(state => state.tenantProfile?.accessToken);
    const dispatch = useDispatch();
    const handleForbiddenErrors = () => {
        dispatch(clearToken());
    }
    const client = useMemo(() => {
        const isTenant = true;
        if (useAccessToken && (accessToken === '' || accessToken == null)) {
            return null;
        }
        const loginUrl = `/${constants.pages.tenantProfile}/login`;
        return new ServerData(null, null, { accessToken, isTenant }, loginUrl, handleForbiddenErrors);
    }, [accessToken]);
    return client;
}
